function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Marketing-collateral-genrator",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.8
}, React.createElement("g", {
  id: "3.0-Choose-Content--option1",
  transform: "translate(-831.000000, -429.000000)",
  fillRule: "nonzero",
  stroke: "#636363"
}, React.createElement("g", {
  id: "noun_Info_2732358-Copy",
  transform: "translate(832.000000, 430.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M12,0 C5.3877551,0 0,5.3877551 0,12 C0,18.6122449 5.3877551,24 12,24 C18.6122449,24 24,18.6122449 24,12 C24,5.3877551 18.6122449,0 12,0 L12,0 Z M12,17.7306122 C11.5591837,17.7306122 11.1918367,17.3632653 11.1918367,16.922449 C11.1918367,16.4816327 11.5591837,16.1142857 12,16.1142857 C12.4408163,16.1142857 12.8081633,16.4816327 12.8081633,16.922449 C12.8081633,17.3632653 12.4408163,17.7306122 12,17.7306122 L12,17.7306122 Z M14.0571429,12.3673469 C13.9591837,12.4653061 13.8122449,12.5877551 13.6653061,12.7102041 C13.1020408,13.1755102 12.5387755,13.6897959 12.5387755,14.2530612 C12.5387755,14.5469388 12.2938776,14.7918367 12,14.7918367 C11.7061224,14.7918367 11.4612245,14.5469388 11.4612245,14.2530612 C11.4612245,13.1755102 12.2938776,12.4408163 12.9795918,11.877551 C13.1020408,11.755102 13.2489796,11.6571429 13.3714286,11.5346939 C13.9102041,11.0938776 14.2040816,10.4816327 14.2040816,9.82040816 C14.2040816,8.62040816 13.2244898,7.64081633 12.0244898,7.64081633 C10.8244898,7.64081633 9.84489796,8.62040816 9.84489796,9.82040816 C9.84489796,10.1142857 9.6,10.3591837 9.30612245,10.3591837 C9.0122449,10.3591837 8.76734694,10.1142857 8.76734694,9.82040816 C8.76734694,8.00816327 10.2367347,6.53877551 12.0489796,6.53877551 C13.8612245,6.53877551 15.3306122,8.00816327 15.3306122,9.82040816 C15.2816327,10.8 14.8408163,11.7306122 14.0571429,12.3673469 L14.0571429,12.3673469 Z",
  id: "Shape"
})))));

var SvgQuestionIcon = function SvgQuestionIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuestionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question_Icon.16ba5db4.svg";
export { ForwardRef as ReactComponent };